import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
    {
        path: '/artikel',
        name: 'Artikel',
        component: () => import('@/views/Artikel.vue'),
    },
    {
        path: '/artikel/:id',
        name: 'ArtikelForm',
        component: () => import('@/views/ArtikelForm.vue'),
    },
    {
        path: '/auftraege',
        name: 'Auftraege',
        component: () => import('@/views/Auftraege.vue'),
    },
    {
        path: '/demo-slots',
        name: 'DemoSlots',
        component: () => import('@/views/DemoSlots.vue'),
    },
    {
        path: '/demo-actions',
        name: 'DemoActions',
        component: () => import('@/views/DemoActions.vue'),
    },
    {
        path: '/demo',
        name: 'Demo',
        component: () => import('@/views/Demo.vue'),
    },
    {
        path: '/icons',
        name: 'Icons',
        component: () => import('@/views/Icons.vue'),
    },
    {
        path: '/filialkunden',
        name: 'Filialkunden',
        component: () => import('@/views/Filialkunden.vue'),
    },
    {
        path: '/filialartikel',
        name: 'Filialartikel',
        component: () => import('@/views/FilialArtikel.vue'),
    },
    {
        path: '/filialartikelpreise',
        name: 'Filialartikelpreise',
        component: () => import('@/views/FilialArtikelPreise.vue'),
    },
    {
        path: '/filialen',
        name: 'Filialen',
        component: () => import('@/views/Filialen.vue'),
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

export default router;
